export default import.meta.ROLLDOWN_FILE_URL_h5fhoLVux4jNUSCVsDpS0w